import { useScrollReveal } from '@/hooks/useScrollReveal';

const carouselItems = [
  {
    title: '那些温暖了整个2026的正能量黑料',
    desc: '回顾上半年最令人动容的三十个正能量爆料故事，从明星善举到素人英雄，每一个温暖瞬间都值得被记住和传颂。',
    tag: '年度盘点',
    tagColor: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=abstract%20warm%20golden%20composition%20representing%20yearly%20review%20and%20celebration%20of%20positive%20stories%2C%20flowing%20interconnected%20geometric%20shapes%20in%20amber%20and%20coral%20tones%2C%20elegant%20timeline%20concept%2C%20editorial%20magazine%20style%2C%20sophisticated%20luminous%20atmosphere%2C%20premium%20design%20aesthetic&width=1000&height=500&seq=carousel-01-v2&orientation=landscape',
  },
  {
    title: '从被黑到圈粉：明星正能量逆袭黑料盘点',
    desc: '那些曾被负面新闻缠身的艺人，如何用真诚行动扭转舆论，最终收获大众认可与尊重的正能量逆袭故事。',
    tag: '星闻聚焦',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=abstract%20transformation%20concept%20with%20ascending%20warm%20toned%20shapes%2C%20dramatic%20lighting%20effect%20from%20dark%20to%20golden%2C%20sophisticated%20editorial%20composition%2C%20flowing%20organic%20patterns%2C%20modern%20magazine%20aesthetic%2C%20elegant%20atmospheric%20design&width=1000&height=500&seq=carousel-02-v2&orientation=landscape',
  },
  {
    title: '都市夜归人：深夜街头发生的十个暖心瞬间',
    desc: '凌晨的城市里，有加班到深夜的打工人，有凌晨出摊的早点铺老板，还有那些不期而遇的善意与温暖。',
    tag: '城市故事',
    tagColor: 'bg-secondary-500',
    image: 'https://readdy.ai/api/search-image?query=abstract%20warm%20night%20cityscape%20concept%20with%20golden%20lights%20and%20flowing%20shapes%2C%20atmospheric%20urban%20feel%20in%20amber%20and%20coral%20tones%2C%20editorial%20magazine%20style%2C%20sophisticated%20luminous%20composition%2C%20elegant%20modern%20design&width=1000&height=500&seq=carousel-03-v2&orientation=landscape',
  },
  {
    title: '正能量创作者专访：用内容改变千万人的故事',
    desc: '对话五位知名正能量内容创作者，揭秘他们幕后的创作故事、初心与坚持，以及那些不为人知的艰辛与收获。',
    tag: '人物专访',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=abstract%20portrait%20interview%20concept%20with%20warm%20golden%20geometric%20shapes%2C%20elegant%20flowing%20composition%20representing%20conversation%20and%20connection%2C%20editorial%20magazine%20aesthetic%2C%20sophisticated%20atmospheric%20lighting%2C%20premium%20design&width=1000&height=500&seq=carousel-04-v2&orientation=landscape',
  },
  {
    title: '黑料718一周年：从零到百万读者的成长之路',
    desc: '平台创立一年来的真实数据与幕后故事，感谢每一位读者的支持与陪伴，未来我们继续一起发现更多温暖。',
    tag: '平台动态',
    tagColor: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=abstract%20celebration%20and%20growth%20concept%20with%20radiating%20warm%20golden%20shapes%2C%20elegant%20flowing%20geometric%20patterns%20representing%20milestone%20achievement%2C%20editorial%20magazine%20style%2C%20sophisticated%20luminous%20atmosphere%2C%20anniversary%20theme&width=1000&height=500&seq=carousel-05-v2&orientation=landscape',
  },
  {
    title: '未来可期：2026下半年正能量趋势深度预测',
    desc: '基于上半年数据与热点分析，展望下半年最值得关注的正能量话题方向、内容趋势与行业变化。',
    tag: '趋势分析',
    tagColor: 'bg-secondary-500',
    image: 'https://readdy.ai/api/search-image?query=abstract%20future%20trends%20concept%20with%20forward%20moving%20warm%20toned%20geometric%20shapes%2C%20ascending%20lines%20representing%20growth%20and%20prediction%2C%20editorial%20magazine%20aesthetic%2C%20sophisticated%20luminous%20atmosphere%2C%20analytical%20theme&width=1000&height=500&seq=carousel-06-v2&orientation=landscape',
  },
];

export default function CarouselSection() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="carousel" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/60 px-3 py-1 rounded-full mb-3">
            深度策划
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大深度专题策划，一站纵览黑料718的精华内容与独家视角
          </p>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/25 to-transparent"></div>
                <span className={`absolute top-3 left-3 ${item.tagColor} text-background-50 text-xs px-3 py-1.5 rounded-full whitespace-nowrap font-medium`}>
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2.5 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}